const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const EnragedCondition = require('../../conditions/EnragedCondition');
const CCHandler = require('../../CCHandler');
const { logError } = require('../../logger');
const { getAbilityLevel } = require('../../../isomorphic-helpers');

const Taunt = function(battleState) {
  this.handle = 'taunt';
  this.magic = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return;
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const alliesOfVictim = BattleCalc.getAlliesOfUnit(victim, battleState.allUnits, false);
      let victims = [];

      for (let i = 0; i < alliesOfVictim.length; ++i) {
        var ally = alliesOfVictim[i];
        if (BattleCalc.adjacent(victim,ally)) {
          victims.push(ally);
        }
      }

      // sort the victims by willpower
      victims.sort((a,b)=>{
        const aAtts = a.attributes;
        const aWP = aAtts.base.willpower + aAtts.fromUpgrades.willpower + aAtts.fromEquipment.willpower + aAtts.fromConditions.willpower;
        const bAtts = b.attributes;
        const bWP = bAtts.base.willpower + bAtts.fromUpgrades.willpower + bAtts.fromEquipment.willpower + bAtts.fromConditions.willpower;
        return aWP - bWP;
      });

      const ability_level = getAbilityLevel({ ability_handle: ability.handle, unit_build: actor });
      victims = victims.slice(0, ability_level-1);
      victims.push(victim);

      const enragedConditions = [];
      for (let i = 0; i < victims.length; ++i) {
        if (!CCHandler.checkForResistRage(victims[i],battleState)) {
          var enraged = new EnragedCondition(actor, victims[i], battleState, ability.duration);
          enraged.instigatorId = actor.uid;
          enraged.ownerId = victims[i].uid;
          battleState.onUnitCondition(enraged);
          enragedConditions.push(enraged);
        }
      }

      const result = { enragedConditions };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Taunt',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = Taunt;
